<template>
  <b-modal
    id="terms-modal"
    modal-class="common-modal"
    hide-footer
  >
    <template slot="modal-header">
      <h5 class="modal-title">{{ $t('general.terms') }}</h5>
      <button @click="hideModal()" class="close"></button>
    </template>

    <template slot="default">
      <div class="info" v-html="$t('general.terms')" style="text-align: justify;"></div>

      <div class="form-actions center">
        <b-button type="button" variant="bordered" @click="hideModal()">{{ $t('general.close') }}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
@import "./Terms";
</style>

<script>
export default {
  methods: {
    hideModal() {
      this.$bvModal.hide('terms-modal');
    },
  },
};
</script>
